<template>
  <div data-component="TravelFromForm">
    <h2 class="gl_form-title">
      {{ t('copy_travel_from_form_title') }}
    </h2>
    <RadioButtonGroup
      id="from"
      :value="from"
      :options="options"
      v-model="from"
      :rules="[validationRules.required]"
    />
  </div>
</template>
<script setup lang="ts">
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { RadioButtonGroupComponent as RadioButtonGroup } from '@/modules/core/components'
  import { useRules } from '@/modules/core/composables/useRulesComposable'
  import type TravelConfigurations from '@/modules/travel/common/models/APP/TravelConfigurations'
  import type TravelRaterAnswers from '@/modules/travel/rater/models/APP/TravelRaterAnswers'

  const { t } = useI18n()
  const { required } = useRules()

  defineExpose({ triggerSubmit })

  interface PropsInterface {
    nextForm: String[]
    answers: TravelRaterAnswers
    configurations: TravelConfigurations
  }
  const props: PropsInterface = withDefaults(defineProps<PropsInterface>(), {})
  const validationRules = {
    required
  }

  const options = [
    { label: t(`copy_travel_from_form_spain_${props.answers.forWhom}`), value: 'spain' },
    { label: t(`copy_travel_from_form_other_${props.answers.forWhom}`), value: 'other' }
  ]

  const from = ref(props.answers.from ?? 'spain')

  async function triggerSubmit() {
    const page = from.value === 'other' ? undefined : props.nextForm[0]
    const answers = {
      from: from.value
    }

    return { page, answers }
  }
</script>
